<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="users"
      :options.sync="options"
      :loading="loading"
      :totalData="totalUsers"
      :customTopActions="true"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >
      <template v-slot:top>
        <TableTopUser
          :loading="loading"
          @addItem="addItem"
          @getData="getData"
          @exportItem="exportItem"
        />
      </template>

      <template v-slot:body-prepend>
        <TableFilter :search.sync="search" :options.sync="options" v-on:getDataParent="getData" />
      </template>
      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell">
          <v-icon small class="mr-2" @click="viewItem(item)"> mdi-eye </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </td>
      </template>
    </TableView>

    <DialogConfirmation
      :dialogView.sync="dialogView" 
      :dialog.sync="dialog" 
      :dialogDelete.sync="dialogDelete"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      :loadingDelete="loadingDelete"
      @close="close"
      @closeDelete="closeDelete"
      @deleteItemConfirm="deleteItemConfirm"
    />
  </v-card>
</template>

<script>

import userMixin from '../../components/user-management/list-user/userMixin';
import { TableFilter, TableTopUser, DialogConfirmation } from '../../components/user-management/list-user/components';


export default {
  mixins: [userMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableFilter,
    TableTopUser, 
    DialogConfirmation
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>

<style scoped>
.td1 {
  width: 35%;
  text-align: left;
  vertical-align: top;
}
.td2 {
  width: 15%;
  text-align: center;
  vertical-align: top;
}
.td3 {
  width: 50%;
  text-align: left;
  vertical-align: top;
}
</style>
